<script>
  import Button from "../../../Components/Common/Button.svelte";
  import PageLoading from "../../../Components/Common/PageLoading.svelte";
  import { apiMethods } from "../../../Services/index.svelte";
  import { deleteIcon, downLoadIcon } from "../../../Utils/utilConstants.svelte";
  import {
    getFormatDateAndTime,
    handleDownloadPDF,
    showError,
  } from "../../../Utils/utilFunctions.svelte";

  export let isModalOpen = false,
    zIndex = 1001,
    allEncounterIds;

  let allFiles = [],
    isLoading = false;

  const checkEncounterFiles = () => {
    if (!allEncounterIds || !allEncounterIds.length) return;
    isLoading = true;
    allFiles = [];
    apiMethods.getMethod
      .getOcrList(0, 999, {
        "filter[patientEncounterId]": allEncounterIds.join(),
      })
      .then((res) => {
        if (res.error) throw res.error;
        if (res.results?.length) {
          const filteredFiles = [];
          res.results.forEach((file) => {
            if (
              !filteredFiles.some(
                (filteredFile) => filteredFile.pdfId === file.pdfId
              )
            )
              filteredFiles.push(file);
          });
          if (filteredFiles.length)
            filteredFiles.sort(
              (a, b) =>
                new Date(b.createdDate).getTime() -
                new Date(a.createdDate).getTime()
            );
          allFiles = filteredFiles;
        }
        isLoading = false;
      })
      .catch((err) => {
        showError(err);
        isLoading = false;
      });
  };

  const downloadFile = async (file) => {
    if (!file.pdfId) return showError("PDF ID Missing.");
    await apiMethods.getMethod
      .getAccountSchedulePDF(file.pdfId)
      .then((res) => {
        if (!res.pdfContent)
          throw "Failed to load the schedule PDF content, please refresh the page and try again and contact support if the issue persists.";
        else handleDownloadPDF(res.pdfContent, "Account Schedule", true);
      })
      .catch((err) => {
        showError(err);
      });
  };

  const deleteFile = async (file) => {
     var deletedListId = await apiMethods.deleteMethod.deleteOcrScheduleListLink(file.pdfId);
     if(deletedListId <= 0){
      showError("List could not be removed. Please contact system administrator")
     } else {
      checkEncounterFiles(); //to reload
     }

  }

  const closeModal = () => {
    isModalOpen = false;
    allFiles = [];
    isLoading = false;
  };
</script>

{#if isModalOpen}
  <div
    class={isModalOpen ? `modal modal-open` : "modal"}
    style="z-index: {zIndex};"
    use:checkEncounterFiles
  >
    <div
      class="modal-box no-transform overflow-visible p-0 flex flex-col justify-between"
    >
      <div
        class="flex flex-1 items-start justify-between font-medium text-lg rounded-tl-lg rounded-tr-lg text-[#fff] flex-0 bg-[#8a3ed7] px-6 py-3"
      >
        <p>List Files</p>
      </div>
      <div class="flex flex-col flex-1 gap-y-4 py-4 px-6">
        {#if isLoading}
          <div class="my-12">
            <PageLoading />
          </div>
        {:else if allFiles?.length}
          <div class="flex-1 flex-col overflow-y-scroll max-height-50vh">
            <div
              class="col-span-4 grid grid-cols-4 gap-3 files-row items-center sticky py-2"
            >
              <span class="col-span-3">Upload Date</span>
              <span class="col-span-1" />
            </div>
            {#each allFiles as file}
              <div
                class="col-span-4 grid grid-cols-4 gap-3 files-row items-end py-2"
              >
                <span class="col-span-3">
                  {getFormatDateAndTime(file.createdDate)}
                </span>
                <div class="col-span-1 flex flex-row gap-x-2">
                  <button
                    class="btn btn-sm btn-circle btn-ghost"
                    on:click={() => downloadFile(file)}
                  >
                    <i class={downLoadIcon} />
                  </button>
                  <button
                    class="btn btn-sm btn-circle btn-ghost"
                    on:click={() => deleteFile(file)}
                  >
                    <i class={deleteIcon} />
                  </button>
                </div>
              </div>
            {/each}
          </div>
        {:else}
          No files available under this list
        {/if}
      </div>

      <div class="flex items-center justify-end gap-x-4 p-4">
        <div class="flex items-center gap-x-4">
          <Button manualClass="w-auto btn-secondary" clickFunc={closeModal}>
            Close
          </Button>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .files-row + .files-row {
    border-top: 1px dashed #a2c0d4;
  }

  .max-height-50vh {
    max-height: 50vh;
  }
</style>
